module.exports = __webpack_public_path__ + "rs.484a005a01dcbbb10a6b.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/rs.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/rs.svg
// module chunks = styles